import {library} from '@fortawesome/fontawesome-svg-core';
import {
	faCheckCircle,
	faCircle,
	faCloudDownload,
	faCloudUpload,
	faCopy,
	faExclamationCircle,
	faInfoCircle,
	faMinusCircle,
	faPencil,
	faPlusCircle,
	faQuestionCircle,
	faShare,
	faSync,
	faTimesCircle,
	faBan,
} from '@fortawesome/pro-light-svg-icons';

import {
	faCheckCircle as fasCheckCircle,
	faCircle as fasCircle,
	faCloudDownload as fasCloudDownload,
	faCloudUpload as fasCloudUpload,
	faCopy as fasCopy,
	faExclamationCircle as fasExclamationCircle,
	faInfoCircle as fasInfoCircle,
	faMinusCircle as fasMinusCircle,
	faPencil as fasPencil,
	faPlusCircle as fasPlusCircle,
	faQuestionCircle as fasQuestionCircle,
	faShare as fasShare,
	faSync as fasSync,
	faTimesCircle as fasTimesCircle,
	faSortAlt as fasSort,
	faSortAlphaUp as fasSortUp,
	faSortAlphaDown as fasSortDown,
	faChevronUp as fasChevronUp,
	faChevronDown as fasChevronDown,
	faBars as fasBars,
	faFile as fasFile,
	faDownload as fasDownload,
	faPlus as fasPlus,
	faTrash as fasTrash,
	faSave as fasSave,
	faFilter as fasFilter,
	faGlobeAmericas as fasGlobeAmericas,
	faCheck as fasCheck,
	faTimes as fasTimes,
	faEye as fasEye,
	faEyeSlash as fasEyeSlash,
	faUsers as fasUsers,
	faUserUnlock as fasUserUnlock,
	faBooks as fasBooks,
	faCalendar as fasCalendar,
	faCamera as fasCamera,
	faClipboardList as fasClipboardList,
	faTreeAlt as fasTreeAlt,
	faSun as fasSun,
	faFileChartLine as fasFileChartLine,
	faBan as fasBan,
	faBallotCheck as fasBallotCheck,
} from '@fortawesome/pro-solid-svg-icons';

library.add(
	faPencil,
	faTimesCircle,
	faMinusCircle,
	faInfoCircle,
	faPlusCircle,
	faQuestionCircle,
	faShare,
	faCloudDownload,
	faCloudUpload,
	faCopy,
	faCheckCircle,
	faExclamationCircle,
	faCircle,
	faSync,
	faBan,
	
	// solid
	fasPencil,
	fasTimesCircle,
	fasMinusCircle,
	fasInfoCircle,
	fasPlusCircle,
	fasQuestionCircle,
	fasShare,
	fasCloudDownload,
	fasCloudUpload,
	fasCopy,
	fasCheckCircle,
	fasExclamationCircle,
	fasCircle,
	fasSort,
	fasSortUp,
	fasSortDown,
	fasSync,
	fasChevronUp,
	fasChevronDown,
	fasBars,
	fasFile,
	fasDownload,
	fasPlus,
	fasTrash,
	fasSave,
	fasFilter,
	fasGlobeAmericas,
	fasCheck,
	fasTimes,
	fasEye,
	fasEyeSlash,
	fasUsers,
	fasUserUnlock,
	fasBooks,
	fasCalendar,
	fasCamera,
	fasClipboardList,
	fasTreeAlt,
	fasSun,
	fasFileChartLine,
	fasBan,
	fasBallotCheck,
);
